




































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./add.vue";
import Edit from "./edit.vue";

import Items from "./items.vue";

@Component({
  components: {
    Add,
    Edit,
    Items
  }
})
export default class extends Mixins(MyList) {
  itemsModalVisible = false;

  dispatchType = "options/list";

  deleteConfirmContent = "你确定要删除该配置及配置下边的配置项吗？";

  dispatchTypeDelete = "options/delete";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "名称", dataIndex: "name" },
    { title: "标识", dataIndex: "code" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }

  showItemsModal(id: number) {
    this.editId = id;
    this.itemsModalVisible = true;
  }

  hideItemsModal() {
    this.itemsModalVisible = false;
  }
}
